import { z } from 'zod';
/**
 * Aviso de versão nova na loja. O app (a partir do pacote 8) pergunta ao abrir,
 * dizendo a versão instalada e, quando a loja já contou, a disponível. Se houver
 * novidade que a pessoa ainda não viu, o Secretário posta na conversa fixa
 * (sem modelo), com as novidades e o caminho para atualizar.
 */
export const APP_STORE_PLATFORMS = ['android', 'ios'];
export const updateCheckSchema = z.object({
    platform: z.enum(APP_STORE_PLATFORMS),
    /** versionCode (Android) ou build (iOS) instalado. */
    installedCode: z.number().int().min(1).max(1_000_000),
    /** O que a loja diz que já está publicado (Play In-App Updates), quando diz. */
    availableCode: z.number().int().min(1).max(1_000_000).nullable().optional(),
});
export const updateCheckResultSchema = z.object({
    /** Tem versão nova publicada para esta pessoa. */
    available: z.boolean(),
    /** O Secretário acabou de postar o aviso agora (o app avisa com um toque). */
    posted: z.boolean(),
    versionName: z.string().nullable(),
    highlights: z.array(z.string()).max(6),
    storeUrl: z.string().nullable(),
});
export const ANDROID_PACKAGE = 'net.secretarios.app';
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
